export const getRoleChecks = (role) => {
  const isManager = role === 'Manager';
  const isPlanner = role === 'Planner';
  const isUser = role === 'User';

  return { isManager, isPlanner, isUser };
};
